export const environment = {
  production: true,
  connection: {
    name: 'LH Thermenland Softline',
    host: 'https://softline.lagerhaus-thermenland.at/',
    port: 443,
    basePath: '/api',
  },
  androidUpdateRepository: '',
};
